const API_URL = `http://qcan-dev.smart-era.com:8001/cl/v1`;

export function fetchTKModel(productSheetId, updateServerData) {
    const fetchData = async () => {
        const response = await fetch(`${API_URL}/product-sheet/${productSheetId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            },
        });

        return response.json();
    };

    fetchData().then((data) => {
        updateServerData(data);
    });
}